module.exports = __webpack_public_path__ + "b268260012f1d55a72ce3e3382275f77.svg";